export default __webpack_public_path__ + "static/media/solution-thinking.f72faf31.svg";